import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseApiService } from '../../base-service/base-api.service';
import { PrintModel } from '../../models/output/print.model';

@Injectable()
export class PrintService extends BaseApiService {

    private _pdfDownloadUrlTemplate = 'foundation/print/GetDocument/';

    public getControllerName(model: any): string {
        var controller = 'Foundation/Print';
        if (model && model.correspondenceId && model.correspondenceId > 0) {
            // using correspondence
            controller = 'Correspondence/Template';
            if (model.modelData && typeof (model.modelData) != 'undefined') {
                // stringify modeldata
                model.modelData = JSON.stringify(model.modelData);
            }
        }
        return controller;
    }

    public getPdf(model: PrintModel) {
        var controller: string = this.getControllerName(model);

        return this.post(controller + '/GetDocument', model, this.replacer, 'application/octet-stream').pipe(
            catchError(this.handleError));
    }

    public storePdf(model: PrintModel) {

        var controller: string = this.getControllerName(model);
        return this.post(controller + '/GetDocumentDownloadId', model, this.replacer, 'text/plain').pipe(
            catchError(this.handleError));
    }

    public getCss(href: string) {
        return this.getAbsolute(href, 'text/css').pipe(catchError(this.handleError));
    }

    public getPdfDownloadUrl(id: string) {
        return this.serviceUrl + this._pdfDownloadUrlTemplate + id;
    }

    public getPdfByUrl(href: string) {
        return this.getAbsolute(href, 'application/pdf').pipe(catchError(this.handleError));
    }

    public getPdfAsStringUrl(id: string) {
        return 'Foundation/Print/GetDocumentAsString/' + id;
    }

    public getPdfAsString(id: string) {
        return this.getDocumentAsStream(this.getPdfAsStringUrl(id));
    }

    public getDocumentAsStream(url: string) {
        return this.get(url, 'application/octet-stream').pipe(catchError(this.handleError));
    }

    public getAbsoluteDocumentAsStream(url: string) {
        return this.getAbsolute(url, 'arraybuffer').pipe(catchError(this.handleError));
    }

    public getHtml(href: string) {
        return this.getAbsolute(href, 'text/HTML').pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            var errorObject = {
                httpStatus: error.status,
                response: error.error
            };
            return observableThrowError(errorObject);
        } else {
            return observableThrowError('Server error');
        }
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }

        return value;
    }

}
